import EditPeIntegration from './EditPeIntegration';

export default EditPeIntegration;
